export enum CertificateType {
  LetsEncrypt = 'letsEncrypt',
  Custom = 'custom',
  SelfSigned = 'selfSigned',
}
